import { ajustesGlobalesIaFormModel } from './ajustesGlobalesIaFormModel';

const {
    formField: {
        defaultChatServiceId,
        defaultImageServiceId,
        defaultAudioServiceId,
        defaultEmbeddingServiceId,
        defaultOcrServiceId,
        creditsPerUsd,
        defaultTemperature,
        defaultTopP,
        defaultMaxTokens,
        enableStreaming,
        enableMemory,
        enableCache,
        enableTools,
        enableLogs,
        allowBringYourOwnKey
    }
} = ajustesGlobalesIaFormModel;

export const formInitialValues = {
    [defaultChatServiceId.name]: undefined,
    [defaultImageServiceId.name]: undefined,
    [defaultAudioServiceId.name]: undefined,
    [defaultEmbeddingServiceId.name]: undefined,
    [defaultOcrServiceId.name]: undefined,
    [creditsPerUsd.name]: '',
    [defaultTemperature.name]: '',
    [defaultTopP.name]: '',
    [defaultMaxTokens.name]: '',
    [enableStreaming.name]: false,
    [enableMemory.name]: false,
    [enableCache.name]: false,
    [enableTools.name]: false,
    [enableLogs.name]: false,
    [allowBringYourOwnKey.name]: false
};
